import { render, staticRenderFns } from "./UserWelcome.vue?vue&type=template&id=39a01220&scoped=true"
import script from "./UserWelcome.vue?vue&type=script&lang=js"
export * from "./UserWelcome.vue?vue&type=script&lang=js"
import style0 from "./UserWelcome.vue?vue&type=style&index=0&id=39a01220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a01220",
  null
  
)

export default component.exports